
import { defineComponent } from "vue";
import LogOut from "../../components/Authentication/LogOut/LogOut.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "LogOutPage",
  components: {
    LogOut,
    MainFooter,
  },
});
